
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fcus_uf1ni_99",
  "clickable": "awsui_clickable_1fcus_uf1ni_108",
  "precise": "awsui_precise_1fcus_uf1ni_112",
  "focus-outline": "awsui_focus-outline_1fcus_uf1ni_116",
  "application": "awsui_application_1fcus_uf1ni_125"
};
  